var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"ma-0 font-13"},[_c('span',{staticClass:"font-weight-medium"},[_vm._v("Formato do arquivo:")]),_c('span',{staticClass:"pl-1 text-azul-link text-decoration-underline cursor-pointer",on:{"click":_vm.baixarArquivo}},[_vm._v("baixar modelo")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }